import React from 'react';
import classnames from 'classnames';

const FilterCheckbox = ({
                          type = 'checkbox',
                          fieldName,
                          label,
                          handleBlur,
                          value,
                          handleSubmit,
                          setFieldValue,
                          containerStyles = 'col-lg mb-0'
                        }) => {
  return (
    <div className={classnames('d-flex justify-content-between', containerStyles)}>
      <input
        id={fieldName}
        type={type}
        className="form-control custom-form-control d-none custom-grid-checkbox"
        name={fieldName}
        placeholder={label}
        onBlur={handleBlur}
        checked={value}
        onChange={(e) => {
          setFieldValue(fieldName, e.target.checked);
          handleSubmit();
        }}
      />
      <label
        htmlFor={fieldName}
        className={`custom-checkbox mb-0 custom-checkbox-size`}
      >

        <div className={'text-nowrap custom-brand-color font-size-lg ml-2'}>
          {label}
        </div>
      </label>
    </div>
  );
};

export default FilterCheckbox;
